/**
 * Basic Authentication patterns:
 *
 * Detects Basic Auth credentials in URLs or configuration strings.
 * Format: http(s)://username:password@host or basic auth headers
 *
 * Patterns:
 * 1. URL with credentials: protocol://user:pass@host
 * 2. Authorization header: Basic base64encoded
 *
 * Examples:
 * - `https://user:password123@example.com`
 * - `http://admin:secret@api.example.com/path`
 * - `Authorization: Basic dXNlcjpwYXNzd29yZA==`
 *
 * References:
 * - https://github.com/secretlint/secretlint/blob/master/packages/%40secretlint/secretlint-rule-basicauth/src/index.ts
 * - https://developer.mozilla.org/en-US/docs/Web/HTTP/Authentication#basic_authentication_scheme
 */

export const basicAuthUrl =
  /\b(?:(http|ftp)s?:\/\/)([a-zA-Z0-9._-]+):([^@\s]+)@([a-zA-Z0-9.-]+)/;

export const basicAuthHeader =
  /\bAuthorization:\s*Basic\s+([A-Za-z0-9+/=]{20,})/i;
